import { truncateText } from "../../../Utils/TextUtils";
import { useAuth } from "../../context/Auth";
import { AddBtnicon } from "../../icons/Icon2";
import styles from "../FormComponents/FromComponent.module.css";
import { useState, useEffect, useRef } from "react";

const DDropDown = ({
  label,
  options,
  listLabel,
  onSelect,
  onReject,
  value,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);

  const { mode } = useAuth();

  const handleOptionSelect = (option) => {
    if (value && value.value === option.value) {
      onReject();
    } else {
      onSelect(option);
    }

    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={styles.drop_down_container} ref={dropdownRef}>
      <p
        className={styles.drop_down_label}
        style={mode ? { color: "#fff" } : {}}
      >
        {label}
      </p>

      <div className={styles.drop_down_select1}>
        <div
          className={styles.drop_down_trigger1}
          style={
            mode
              ? {
                  backgroundColor: "#1B1D21",
                  borderColor: "#1B1D21",
                }
              : {}
          }
          onClick={() => setIsOpen(!isOpen)}
        >
          <div
            className={styles.drop_down_placeholder}
            style={{ color: mode ? "#fff" : "#646b88" }}
          >
            <>
              <p>{value ? value.label : listLabel || "Select"}</p>

              <AddBtnicon mode={mode} rotate={isOpen ? 180 : 0} />
            </>
          </div>
        </div>

        {isOpen && (
          <ul
            className={styles.drop_down_list}
            style={
              mode
                ? {
                    backgroundColor: "#232529",
                    border: "none",
                  }
                : {}
            }
          >
            {options.map((option, index) => (
              <li
                key={index}
                className={`${styles.drop_down_item} ${
                  mode ? styles.drop_down_item_dark : ""
                }`}
                onClick={() => handleOptionSelect(option)}
              >
                {truncateText(option.label, 19)}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default DDropDown;
